import {
    SET_STUDENT_PAYMENT_DATA,
    SHOW_STUDENT_PAYMENT_DIALOG,
    SET_STUDENT_MISC_PAYMENT_DATA,
    SHOW_TEACHER_PAYMENT_DIALOG,
    SET_GENERAL_DATA,
    SET_TEACHER_SALARY_DATA,
    SET_TEACHER_SALARY_DETAIL,
    IS_LOADING,
    SET_ALERT_DIALOG_CONTENT,
    SET_PAYMENT_HISTORY_DATA,
    SET_FINANCE_REPORT_STUDENTS_DATA,
    SET_FINANCE_REPORT_MONTHLY_DATA,
    SET_STUDENT_RECEIPTS_DATA
} from "../types";
import api from "../../utils/api";
import {PAYMENT_TYPE_TEACHER_HOUR} from "../../utils/constants";

export const paymentActions = (props) => {
  return {
      getStudentPayments: (month, name, programLvl) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/students/payment?` +
                  `month=${month}` +
                  `&name=${name? name : ""}` +
                  `&programLvl=${programLvl? programLvl : ""}`
              )
              .then(res => {
                  const data = res.data;
                  for (let i=0; i < data.length; i ++) {
                      data[i].totalOwedFee = data[i].totalOwedFee/100;
                      data[i].totalTuitionFee = data[i].totalTuitionFee/100;
                  }
                 props.dispatch({ type: IS_LOADING, data: false });
                 props.dispatch({ type: SET_STUDENT_PAYMENT_DATA, data: {studentPayment: data} })
              })
              .catch(error => {
                    props.dispatch({ type: IS_LOADING, data: false });
                    props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                    });
              });
          },
      getStudentReceipts: (month, name, programLvl) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/students/receipts?` +
                  `transactionDate=${month}` +
                  `&name=${name? name : ""}` +
                  `&programLvl=${programLvl? programLvl : ""}`
              )
              .then(res => {
                  const data = res.data.students;
                  for (let i=0; i < data.length; i ++) {
                      data[i].totalAmount = data[i].totalAmount/100;
                  }
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_STUDENT_RECEIPTS_DATA, data: {studentReceipts: data} })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },
      getSingleStudentPaymentDetail: (studentUuid, month) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/student/payment?` +
                  `uuid=${studentUuid}` +
                  `&month=${month}`
              )
              .then(res => {
                  const data = res.data;
                  for (let i=0; i < data.length; i ++) {
                      data[i].fee = data[i].fee/100;
                  }
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({type: SET_STUDENT_PAYMENT_DATA, data: {studentPaymentDetail: data}})
              })
              .catch(error => {
                    props.dispatch({ type: IS_LOADING, data: false });
                    props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                    });
              });
      },
      getPaymentHistory: (type, uuid) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/payment/history?` +
                  `uuid=${uuid}` +
                  `&type=${type}`
              )
              .then(res => {
                  const data = res.data;
                  for (let i=0; i < data.length; i ++) {
                      data[i].fee = data[i].fee/100;
                  }
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_PAYMENT_HISTORY_DATA, data })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },
      getStudentsFinanceReport: (transactionDate, programLvl) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/finance/report/students?` +
                  `transactionDate=${transactionDate}` +
                  `&programLvl=${programLvl}`
              )
              .then(res => {
                  const data = res.data;
                  for (let i=0; i < data.length; i ++) {
                      data[i].totalAmount = data[i].totalAmount/100;
                  }
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_FINANCE_REPORT_STUDENTS_DATA, data })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },
      getMonthlyFinanceReport: (transactionDate) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/finance/report/month?` +
                  `transactionDate=${transactionDate}`
              )
              .then(res => {
                  const data = res.data;
                  data.bank.totalAmount = data.bank.totalAmount/100;
                  data.cash.totalAmount = data.cash.totalAmount/100;
                  data.unknown.totalAmount = data.unknown.totalAmount/100;
                  data.total.totalAmount = data.total.totalAmount/100;
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_FINANCE_REPORT_MONTHLY_DATA, data })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },
      submitStudentPaymentDetail: (data, refreshThePaymentList) => {
          props.dispatch({ type: IS_LOADING, data: true });
          const payload = JSON.parse(JSON.stringify(data));
          console.log(payload);
          for (let i = 0; i < payload.length; i++){
              payload[i].fee =  payload[i].fee * 100; //convert to sen
          }
          api.qmsService
              .post(`/services/qms/student/payment`, payload)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Thank you",
                      content: "You've made the payment"
                  });
                  if (refreshThePaymentList!=null){
                      console.log("refresh the list")
                      refreshThePaymentList();
                  }
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },

      submitStudentMiscPaymentDetail: (studentUuid, transactionDate, paymentType, data) => {
          const dataCopy = JSON.parse(JSON.stringify(data));

          for (let i=0; i < dataCopy.misc.length; i ++) {
              dataCopy.misc[i].fee = dataCopy.misc[i].fee * 100;
          }


          const payload = {
              studentUuid,
              transactionDate,
              paymentType,
              paymentDetails: [...dataCopy.misc]
          }

          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .post(`/services/qms/student/misc/payment`, payload)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Thank you",
                      content: "You've made the payment"
                  });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },

      getMiscStudentPayments: (month, name, programLvl, itemId) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/students/misc/payment?` +
                  `month=${month}` +
                  `&name=${name? name : ""}` +
                  `&itemId=${itemId? itemId : ""}` +
                  `&programLvl=${programLvl? programLvl : ""}`
              )
              .then(res => {
                  const data = res.data;
                  for (let i=0; i < data.length; i ++) {
                      data[i].totalOwedFee = data[i].totalOwedFee? data[i].totalOwedFee/100 : "NA";
                  }
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_STUDENT_MISC_PAYMENT_DATA, data: {miscStudentPayment: res.data} })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },
      getSingleMiscStudentPaymentDetail: (studentUuid, month) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/student/misc/payment?` +
                  `uuid=${studentUuid}` +
                  `&month=${month}`
              )
              .then(res => {
                  const data = res.data;
                  for (let i=0; i < data.length; i ++) {
                      data[i].fee = data[i].fee/100;
                  }
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({type: SET_STUDENT_MISC_PAYMENT_DATA, data: {miscStudentPaymentDetail: data}})
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },

      getTeachersSalary: (month) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/teachers/salary?month=${month}`)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_TEACHER_SALARY_DATA, data: res.data })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },

      getSingleTeacherSalary: (teacherUuid, month) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .get(`/services/qms/teacher/salary?` +
                  `teacherUuid=${teacherUuid}` +
                  `&month=${month}`)
              .then(res => {
                  const data = res.data;
                  if (data.paymentType === PAYMENT_TYPE_TEACHER_HOUR){
                      data.paymentRate = data.paymentRate/100;
                  }
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_TEACHER_SALARY_DETAIL, data : data })
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },

      submitTeacherPaymentDetail: (data) => {
          props.dispatch({ type: IS_LOADING, data: true });
          api.qmsService
              .post(`/services/qms/teacher/salary`, data)
              .then(res => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Thank you",
                      content: "You've made the payment"
                  });
              })
              .catch(error => {
                  props.dispatch({ type: IS_LOADING, data: false });
                  props.dispatch({ type: SET_ALERT_DIALOG_CONTENT,
                      title: "Oops",
                      content: error.data.error.message
                  });
              });
      },

      showStudentDetailDialog : (data) => {
          props.dispatch({type: SHOW_STUDENT_PAYMENT_DIALOG, data})
      },

      showTeacherPaymentDetailDialog : (data) => {
          props.dispatch({type: SHOW_TEACHER_PAYMENT_DIALOG, data})
      }

    }
}


